import { createsCleaningTasks, isStayBookingActive } from './booking-source';

/** Machine decimal amount; comma is decimal only (including 1,234 → 1.234), never grouping. */
export function bookingAmount(value: unknown): number | null {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (typeof value !== 'string') return null;
  const text = value.trim().replace(/\s*(?:EUR|€)$/, '').trim();
  if (!/^[+-]?(?:\d+(?:[.,]\d*)?|[.,]\d+)$/.test(text)) return null;
  const amount = Number(text.replace(',', '.'));
  return Number.isFinite(amount) ? amount : null;
}

export function bookingPaid(value: unknown): boolean | null {
  if (value === true || value === 1 || value === '1') return true;
  if (value === false || value === 0 || value === '0') return false;
  return null;
}

export interface PriceBooking {
  source?: string; ilocaId?: unknown; priceReadOnly?: boolean; totalAmount?: number | null;
  status?: string; bookingStatus?: string; cancelled?: boolean; blocked?: boolean;
  financial?: { totalAmount?: number | null };
  metadata?: { totalAmount?: number | null; paid?: boolean | null; wasCancelled?: boolean; illocaId?: unknown; ilocaV2BookingId?: unknown; sources?: string[] };
  botBooking?: { replacedByBookingId?: string; enteredInIlocaAt?: unknown };
}

export function isIlocaImported(booking: PriceBooking): boolean {
  return booking.priceReadOnly ?? (createsCleaningTasks(booking) || booking.source?.toUpperCase() === 'ILOCA'
    || booking.ilocaId != null || booking.metadata?.ilocaV2BookingId != null);
}

/** PO 13.10.2026 „iLoca gilt“: no fallback from a missing authoritative import price. */
export function resolveBookingPrice(booking: PriceBooking): number | null {
  return bookingAmount(isIlocaImported(booking) ? booking.metadata?.totalAmount
    : booking.financial ? booking.financial.totalAmount : booking.totalAmount);
}

/** Exact zero, unpaid, active stay. No-show/checked-out/closed bots have no price work. */
export function zeroPriceBooking(booking: PriceBooking): boolean {
  return isStayBookingActive(booking) && resolveBookingPrice(booking) === 0 && booking.metadata?.paid !== true;
}
